module.exports = __webpack_public_path__ + "posture/static/img/high_low_shoulder_right.2a5de87.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/posture/normal/high_low_shoulder_right.png
// module id = UJZ8
// module chunks = 1